import React, { createContext, useContext, useState, useCallback } from 'react';

const TransactionContext = createContext();

export const useTransaction = () => {
  const context = useContext(TransactionContext);
  if (!context) {
    throw new Error('useTransaction must be used within TransactionProvider');
  }
  return context;
};

export const TransactionProvider = ({ children }) => {
  const [pendingTransaction, setPendingTransaction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [resolver, setResolver] = useState(null);

  const requestConfirmation = useCallback((tx, onConfirm, onCancel) => {
    setPendingTransaction(tx);
    setShowModal(true);
    setResolver({ onConfirm, onCancel });
  }, []);

  const confirmTransaction = useCallback(() => {
    if (resolver && resolver.onConfirm) {
      resolver.onConfirm();
    }
    setShowModal(false);
    setPendingTransaction(null);
    setResolver(null);
  }, [resolver]);

  const cancelTransaction = useCallback(() => {
    if (resolver && resolver.onCancel) {
      resolver.onCancel();
    }
    setShowModal(false);
    setPendingTransaction(null);
    setResolver(null);
  }, [resolver]);

  return (
    <TransactionContext.Provider value={{
      pendingTransaction,
      showModal,
      requestConfirmation,
      confirmTransaction,
      cancelTransaction
    }}>
      {children}
    </TransactionContext.Provider>
  );
};
